import { CurrencyFieldText, CurrencyFieldTextProps } from 'app/components/CurrencyTextField';

export const BillingCurrencyFieldText = (props: CurrencyFieldTextProps) => {
  return (
    <CurrencyFieldText
      {...props}
      slotProps={{ input: { style: { fontSize: 14, textAlignLast: 'right' } } }}
    />
  );
};
